// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"67fd159f","628":"c4bcfc6e"}[chunkId] + ".css";
};